import React from 'react';

export * from 'react';
export default React;

export const __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = {
  ReactCurrentDispatcher: { current: null },
  ReactCurrentOwner: { current: null },
};
